/* eslint-disable react/react-in-jsx-scope */
import pdf from '../../pdf/РеестроваяВыписка.pdf'
import './style.css'


const License = () => {
    return (
      <div className="license center">
        <h1 className="license-title">
          СВЕДЕНИЯ ОБ ОБРАЗОВАТЕЛЬНОЙ ДЕЯТЕЛЬНОСТИ
        </h1>
        <div className="license-container">
          <div className="license-box">
            <h2 className="license-txt">ЛИЦЕНЗИЯ</h2>
            <a href={pdf} target="_blank" rel="noreferrer" className="license-btn">перейти</a>
          </div>
        </div>
      </div>
    )
}
 
export default License;